// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Projects_wrapper__1aJhz","header":"Projects_header__2mJ1E","headerWrapper":"Projects_headerWrapper__3cLuW"};